// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//     Box,
//     Grid,
//     TextField,
//     Button,
//     Card,
//     CardContent,
//     CardHeader,
//     Typography,
//     Divider,
//     Container,
//     Alert,
//     Snackbar,
//     IconButton,
//     Tooltip,
//     Paper
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import { toProperCase } from '../utils/formatRows';

// const TermsConditionMaster = ({ mode, id, onPopupCancel, connectionString, companyId: propsCompanyId }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = `${connectionString}/api`;
//     const navigate = useNavigate();

//     const [termsName, setTermsName] = useState('');
//     const [termsRows, setTermsRows] = useState([{ SrNo: 1, Field: '' }]);
//     const [formError, setFormError] = useState('');

//     const username = user?.emailId;
//     const companyId = (() => {
//         if (mode === 'comp' || mode === 'edit') {
//             return propsCompanyId ?? null;
//         }
//         return selectedCompany?.CompId ?? null;
//     })();

//     const AppRegID = selectedCompany?.AppRegID || null;

//     console.log(companyId);

//     const fYear = selectedCompany?.financialYear;
//     const userId = user?.UserId || null;
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     // Load existing data if editing
//     useEffect(() => {
//         if (mode === 'edit' && id) {
//             axios.get(`${path}/termscondition/getDetails/${id}`)
//                 .then(res => {
//                     console.log('Fetched Terms Data:', res.data);

//                     if (res.data && res.data.length > 0) {
//                         setTermsName(res.data[0].TermsName || '');

//                         const rows = res.data.map((item) => ({
//                             SrNo: item.SrNo,
//                             Field: item.TermsDescription || ''
//                         }));

//                         setTermsRows(rows.length > 0 ? rows : [{ SrNo: 1, Field: '' }]);
//                     }
//                 })
//                 .catch(err => console.error('Error fetching terms & condition:', err));
//         }
//     }, [id, mode, path]);

//     // Add new row
//     const handleAddRow = () => {
//         const newSrNo = termsRows.length + 1;
//         setTermsRows([...termsRows, { SrNo: newSrNo, Field: '' }]);
//     };

//     // Delete row
//     const handleDeleteRow = (index) => {
//         if (termsRows.length === 1) {
//             setSnackbar({
//                 open: true,
//                 message: 'At least one term is required',
//                 severity: 'warning'
//             });
//             return;
//         }

//         const updatedRows = termsRows.filter((_, i) => i !== index);
//         const renumberedRows = updatedRows.map((row, idx) => ({
//             ...row,
//             SrNo: idx + 1
//         }));
//         setTermsRows(renumberedRows);
//     };

//     // Update field value
//     const handleFieldChange = (index, value) => {
//         const updatedRows = [...termsRows];
//         updatedRows[index].Field = value;
//         setTermsRows(updatedRows);
//     };

//     // Handle Terms Number change - only allow numbers
//     const handleTermsNameChange = (e) => {
//         const value = e.target.value;
//         const numericValue = value.replace(/[^0-9]/g, '');
//         setTermsName(numericValue);
//     };

//     // Move row UP
//     const handleMoveUp = (index) => {
//         if (index === 0) return;

//         const updatedRows = [...termsRows];
//         const temp = updatedRows[index];
//         updatedRows[index] = updatedRows[index - 1];
//         updatedRows[index - 1] = temp;

//         const renumberedRows = updatedRows.map((row, idx) => ({
//             ...row,
//             SrNo: idx + 1
//         }));

//         setTermsRows(renumberedRows);
//     };

//     // Move row DOWN
//     const handleMoveDown = (index) => {
//         if (index === termsRows.length - 1) return;

//         const updatedRows = [...termsRows];
//         const temp = updatedRows[index];
//         updatedRows[index] = updatedRows[index + 1];
//         updatedRows[index + 1] = temp;

//         const renumberedRows = updatedRows.map((row, idx) => ({
//             ...row,
//             SrNo: idx + 1
//         }));

//         setTermsRows(renumberedRows);
//     };

//     const handleReset = () => {
//         if (onPopupCancel) {
//             onPopupCancel();
//         } else {
//             navigate('/main/termsConditionDetail');
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!termsName.trim()) {
//             setFormError('Terms Number is required.');
//             return;
//         }

//         const hasEmptyField = termsRows.some(row => !row.Field.trim());
//         if (hasEmptyField) {
//             setFormError('All term fields must be filled.');
//             return;
//         }

//         setFormError('');

//         const termsArray = termsRows.map((row) => ({
//             SrNo: row.SrNo,
//             TermsDescription: row.Field.trim()
//         }));

//         const basePayload = {
//             TermsName: termsName,
//             termsArray,
//             companyId,
//             AppRegID,
//             fYear,
//             branchId: selectedCompany?.BranchId || null
//         };

//         let payload;

//         if (mode === 'add' || mode === 'comp') {
//             payload = {
//                 ...basePayload,
//                 addUserId: user?.UserId || null
//             };
//         } else {
//             payload = {
//                 ...basePayload,
//                 editUserId: user?.UserId || null,
//                 termsId: id
//             };
//         }

//         try {
//             if (mode === 'add' || mode === 'comp') {
//                 await axios.post(`${path}/termscondition/Insert`, payload);
//                 setTermsName('');
//                 setTermsRows([{ SrNo: 1, Field: '' }]);
//                 setSnackbar({
//                     open: true,
//                     message: 'Terms & Condition added successfully',
//                     severity: 'success'
//                 });
//                 if (onPopupCancel) {
//                     setTimeout(() => { onPopupCancel() }, 600);
//                 }
//             } else if (mode === 'edit') {
//                 await axios.put(`${path}/termscondition/Update/${id}`, payload);
//                 setSnackbar({
//                     open: true,
//                     message: 'Terms & Condition updated successfully',
//                     severity: 'success'
//                 });
//                 if (onPopupCancel) {
//                     setTimeout(() => { onPopupCancel() }, 600);
//                 }
//             }
//         } catch (err) {
//             console.error('Error saving terms & condition:', err);
//             setFormError('Something went wrong while saving. Please try again.');
//         }
//     };

//     return (
//         <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
//             <Card elevation={3}>
//                 <CardHeader
//                     title={mode === 'add' || mode === 'comp' ? 'Add Terms & Condition' : 'Edit Terms & Condition'}
//                     sx={{
//                         backgroundColor: '#1976d2',
//                         color: '#fff',
//                         textAlign: 'center',
//                         py: 1.5,
//                         '& .MuiCardHeader-title': {
//                             fontSize: '1.1rem',
//                             fontWeight: 600,
//                             color: '#fff'
//                         }
//                     }}
//                 />
//                 <Divider />
//                 <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//                     <form onSubmit={handleSubmit} noValidate>
//                         <Grid container spacing={3}>

//                             {/* Terms Number Field */}
//                             <Grid item xs={12} sm={4}>
//                                 <TextField
//                                     label="Terms Number"
//                                     value={termsName}
//                                     onChange={handleTermsNameChange}
//                                     fullWidth
//                                     required
//                                     placeholder="e.g., 1, 2, 3"
//                                     type="text"
//                                     size="small"
//                                     inputProps={{
//                                         inputMode: 'numeric',
//                                         pattern: '[0-9]*'
//                                     }}
//                                     helperText="Enter numeric value only (e.g., 1, 2, 3)"
//                                 />
//                             </Grid>

//                             {/* Terms & Conditions Rows */}
//                             <Grid item xs={12}>
//                                 <Paper
//                                     variant="outlined"
//                                     sx={{
//                                         p: 2,
//                                         borderRadius: 2,
//                                         backgroundColor: '#fafafa'
//                                     }}
//                                 >
//                                     {/* Header */}
//                                     <Box
//                                         sx={{
//                                             display: 'flex',
//                                             justifyContent: 'space-between',
//                                             alignItems: 'center',
//                                             mb: 2
//                                         }}
//                                     >
//                                         <Typography variant="subtitle1" fontWeight={600} color="text.primary">
//                                             Terms &amp; Conditions
//                                             <Typography
//                                                 component="span"
//                                                 variant="caption"
//                                                 sx={{ ml: 1, color: 'text.secondary' }}
//                                             >
//                                                 ({termsRows.length} {termsRows.length === 1 ? 'term' : 'terms'})
//                                             </Typography>
//                                         </Typography>
//                                         <Button
//                                             variant="contained"
//                                             size="small"
//                                             startIcon={<AddIcon />}
//                                             onClick={handleAddRow}
//                                             sx={{ borderRadius: 2 }}
//                                         >
//                                             Add Term
//                                         </Button>
//                                     </Box>

//                                     <Divider sx={{ mb: 2 }} />

//                                     {/* Column Headers */}
//                                     <Box
//                                         sx={{
//                                             display: 'grid',
//                                             gridTemplateColumns: '50px 1fr 120px',
//                                             gap: 1,
//                                             mb: 1,
//                                             px: 1
//                                         }}
//                                     >
//                                         <Typography variant="caption" fontWeight={600} color="text.secondary" textAlign="center">
//                                             SR.
//                                         </Typography>
//                                         <Typography variant="caption" fontWeight={600} color="text.secondary">
//                                             TERM / CONDITION
//                                         </Typography>
//                                         <Typography variant="caption" fontWeight={600} color="text.secondary" textAlign="center">
//                                             ACTIONS
//                                         </Typography>
//                                     </Box>

//                                     {/* Rows */}
//                                     <Box
//                                         sx={{
//                                             maxHeight: '400px',
//                                             overflowY: 'auto',
//                                             pr: 0.5,
//                                             '&::-webkit-scrollbar': { width: '6px' },
//                                             '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1', borderRadius: '4px' },
//                                             '&::-webkit-scrollbar-thumb': { backgroundColor: '#bdbdbd', borderRadius: '4px' },
//                                             '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#9e9e9e' }
//                                         }}
//                                     >
//                                         {termsRows.map((row, index) => (
//                                             <Paper
//                                                 key={index}
//                                                 elevation={0}
//                                                 sx={{
//                                                     display: 'grid',
//                                                     gridTemplateColumns: '50px 1fr 120px',
//                                                     gap: 1,
//                                                     alignItems: 'flex-start',
//                                                     mb: 1.5,
//                                                     p: 1.5,
//                                                     borderRadius: 2,
//                                                     border: '1px solid',
//                                                     borderColor: 'divider',
//                                                     backgroundColor: index % 2 === 0 ? '#fff' : '#f5f8ff',
//                                                     transition: 'box-shadow 0.2s',
//                                                     '&:hover': {
//                                                         boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                                                         borderColor: 'primary.light'
//                                                     }
//                                                 }}
//                                             >
//                                                 {/* Sr No */}
//                                                 <Box
//                                                     sx={{
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         height: '100%',
//                                                         pt: 0.5
//                                                     }}
//                                                 >
//                                                     <Box
//                                                         sx={{
//                                                             width: 30,
//                                                             height: 30,
//                                                             borderRadius: '50%',
//                                                             backgroundColor: 'primary.main',
//                                                             color: '#fff',
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             justifyContent: 'center',
//                                                             fontSize: '0.75rem',
//                                                             fontWeight: 700,
//                                                             flexShrink: 0
//                                                         }}
//                                                     >
//                                                         {row.SrNo}
//                                                     </Box>
//                                                 </Box>

//                                                 {/* Term Text Field */}
//                                                 <TextField
//                                                     label="Term"
//                                                     value={row.Field}
//                                                     onChange={(e) => handleFieldChange(index, e.target.value)}
//                                                     fullWidth
//                                                     required
//                                                     size="small"
//                                                     multiline
//                                                     minRows={1}
//                                                     maxRows={6}
//                                                     placeholder="Enter term or condition"
//                                                     InputProps={{
//                                                         startAdornment: (
//                                                             <Typography
//                                                                 component="span"
//                                                                 sx={{
//                                                                     mr: 0.5,
//                                                                     color: 'primary.main',
//                                                                     fontWeight: 700,
//                                                                     alignSelf: 'flex-start',
//                                                                     mt: '6px'
//                                                                 }}
//                                                             >
//                                                                 #
//                                                             </Typography>
//                                                         ),
//                                                     }}
//                                                     sx={{
//                                                         '& .MuiOutlinedInput-root': {
//                                                             alignItems: 'flex-start',
//                                                             backgroundColor: '#fff'
//                                                         }
//                                                     }}
//                                                 />

//                                                 {/* Action Buttons */}
//                                                 <Box
//                                                     sx={{
//                                                         display: 'flex',
//                                                         flexDirection: 'row',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         gap: 0.5,
//                                                         pt: 0.5,
//                                                         flexWrap: 'wrap'
//                                                     }}
//                                                 >
//                                                     <Tooltip title="Move Up">
//                                                         <span>
//                                                             <IconButton
//                                                                 color="primary"
//                                                                 onClick={() => handleMoveUp(index)}
//                                                                 disabled={index === 0}
//                                                                 size="small"
//                                                                 sx={{
//                                                                     border: '1px solid',
//                                                                     borderColor: index === 0 ? 'divider' : 'primary.light',
//                                                                     borderRadius: 1,
//                                                                     p: 0.5
//                                                                 }}
//                                                             >
//                                                                 <ArrowUpwardIcon fontSize="small" />
//                                                             </IconButton>
//                                                         </span>
//                                                     </Tooltip>

//                                                     <Tooltip title="Move Down">
//                                                         <span>
//                                                             <IconButton
//                                                                 color="primary"
//                                                                 onClick={() => handleMoveDown(index)}
//                                                                 disabled={index === termsRows.length - 1}
//                                                                 size="small"
//                                                                 sx={{
//                                                                     border: '1px solid',
//                                                                     borderColor: index === termsRows.length - 1 ? 'divider' : 'primary.light',
//                                                                     borderRadius: 1,
//                                                                     p: 0.5
//                                                                 }}
//                                                             >
//                                                                 <ArrowDownwardIcon fontSize="small" />
//                                                             </IconButton>
//                                                         </span>
//                                                     </Tooltip>

//                                                     <Tooltip title="Delete Term">
//                                                         <span>
//                                                             <IconButton
//                                                                 color="error"
//                                                                 onClick={() => handleDeleteRow(index)}
//                                                                 disabled={termsRows.length === 1}
//                                                                 size="small"
//                                                                 sx={{
//                                                                     border: '1px solid',
//                                                                     borderColor: termsRows.length === 1 ? 'divider' : 'error.light',
//                                                                     borderRadius: 1,
//                                                                     p: 0.5
//                                                                 }}
//                                                             >
//                                                                 <DeleteIcon fontSize="small" />
//                                                             </IconButton>
//                                                         </span>
//                                                     </Tooltip>
//                                                 </Box>
//                                             </Paper>
//                                         ))}
//                                     </Box>

//                                     {/* Footer Summary */}
//                                     {termsRows.length > 0 && (
//                                         <Box
//                                             sx={{
//                                                 mt: 1,
//                                                 pt: 1,
//                                                 borderTop: '1px dashed',
//                                                 borderColor: 'divider',
//                                                 display: 'flex',
//                                                 justifyContent: 'flex-end'
//                                             }}
//                                         >
//                                             <Typography variant="caption" color="text.secondary">
//                                                 Total: {termsRows.length} {termsRows.length === 1 ? 'term' : 'terms'}
//                                             </Typography>
//                                         </Box>
//                                     )}
//                                 </Paper>
//                             </Grid>

//                             {/* Error Alert */}
//                             {formError && (
//                                 <Grid item xs={12}>
//                                     <Alert severity="error" sx={{ borderRadius: 2 }}>
//                                         {formError}
//                                     </Alert>
//                                 </Grid>
//                             )}

//                             {/* Action Buttons */}
//                             <Grid item xs={12}>
//                                 <Box
//                                     display="flex"
//                                     justifyContent="flex-end"
//                                     gap={2}
//                                     sx={{
//                                         pt: 1,
//                                         borderTop: '1px solid',
//                                         borderColor: 'divider'
//                                     }}
//                                 >
//                                     <Button
//                                         variant="outlined"
//                                         color="secondary"
//                                         onClick={handleReset}
//                                         sx={{ borderRadius: 2, minWidth: 100 }}
//                                     >
//                                         Cancel
//                                     </Button>
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         type="submit"
//                                         sx={{ borderRadius: 2, minWidth: 100 }}
//                                     >
//                                         {mode === 'add' || mode === 'comp' ? 'Save' : 'Update'}
//                                     </Button>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </form>
//                 </CardContent>
//             </Card>

//             <Snackbar
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 open={snackbar.open}
//                 autoHideDuration={3000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{ width: '100%' }}
//                     variant='filled'
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default TermsConditionMaster;





import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box,
    TextField,
    Button,
    Typography,
    Divider,
    Alert,
    Snackbar,
    IconButton,
    Tooltip,
    Paper,
    Stack,
    Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toProperCase } from '../utils/formatRows';

const TermsConditionMaster = ({ mode, id, onPopupCancel, connectionString, companyId: propsCompanyId }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = `${connectionString}/api`;
    const navigate = useNavigate();

    const [termsName, setTermsName] = useState('');
    const [termsRows, setTermsRows] = useState([{ SrNo: 1, Field: '' }]);
    const [formError, setFormError] = useState('');

    const username = user?.emailId;
    const companyId = (() => {
        if (mode === 'comp' || mode === 'edit') {
            return propsCompanyId ?? null;
        }
        return selectedCompany?.CompId ?? null;
    })();

    const AppRegID = selectedCompany?.AppRegID || null;

    console.log(companyId);

    const fYear = selectedCompany?.financialYear;
    const userId = user?.UserId || null;
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Load existing data if editing
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios.get(`${path}/termscondition/getDetails/${id}`)
                .then(res => {
                    console.log('Fetched Terms Data:', res.data);

                    if (res.data && res.data.length > 0) {
                        setTermsName(res.data[0].TermsName || '');

                        const rows = res.data.map((item) => ({
                            SrNo: item.SrNo,
                            Field: item.TermsDescription || ''
                        }));

                        setTermsRows(rows.length > 0 ? rows : [{ SrNo: 1, Field: '' }]);
                    }
                })
                .catch(err => console.error('Error fetching terms & condition:', err));
        }
    }, [id, mode, path]);

    // Add new row
    const handleAddRow = () => {
        const newSrNo = termsRows.length + 1;
        setTermsRows([...termsRows, { SrNo: newSrNo, Field: '' }]);
    };

    // Delete row
    const handleDeleteRow = (index) => {
        if (termsRows.length === 1) {
            setSnackbar({
                open: true,
                message: 'At least one term is required',
                severity: 'warning'
            });
            return;
        }

        const updatedRows = termsRows.filter((_, i) => i !== index);
        const renumberedRows = updatedRows.map((row, idx) => ({
            ...row,
            SrNo: idx + 1
        }));
        setTermsRows(renumberedRows);
    };

    // Update field value
    const handleFieldChange = (index, value) => {
        const updatedRows = [...termsRows];
        updatedRows[index].Field = value;
        setTermsRows(updatedRows);
    };

    // Handle Terms Number change - only allow numbers
    const handleTermsNameChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        setTermsName(numericValue);
    };

    // Move row UP
    const handleMoveUp = (index) => {
        if (index === 0) return;

        const updatedRows = [...termsRows];
        const temp = updatedRows[index];
        updatedRows[index] = updatedRows[index - 1];
        updatedRows[index - 1] = temp;

        const renumberedRows = updatedRows.map((row, idx) => ({
            ...row,
            SrNo: idx + 1
        }));

        setTermsRows(renumberedRows);
    };

    // Move row DOWN
    const handleMoveDown = (index) => {
        if (index === termsRows.length - 1) return;

        const updatedRows = [...termsRows];
        const temp = updatedRows[index];
        updatedRows[index] = updatedRows[index + 1];
        updatedRows[index + 1] = temp;

        const renumberedRows = updatedRows.map((row, idx) => ({
            ...row,
            SrNo: idx + 1
        }));

        setTermsRows(renumberedRows);
    };

    const handleReset = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/termsConditionDetail');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!termsName.trim()) {
            setFormError('Terms Number is required.');
            return;
        }

        const hasEmptyField = termsRows.some(row => !row.Field.trim());
        if (hasEmptyField) {
            setFormError('All term fields must be filled.');
            return;
        }

        setFormError('');

        const termsArray = termsRows.map((row) => ({
            SrNo: row.SrNo,
            TermsDescription: row.Field.trim()
        }));

        const basePayload = {
            TermsName: termsName,
            termsArray,
            companyId,
            AppRegID,
            fYear,
            branchId: selectedCompany?.BranchId || null
        };

        let payload;

        if (mode === 'add' || mode === 'comp') {
            payload = {
                ...basePayload,
                addUserId: user?.UserId || null
            };
        } else {
            payload = {
                ...basePayload,
                editUserId: user?.UserId || null,
                termsId: id
            };
        }

        try {
            if (mode === 'add' || mode === 'comp') {
                await axios.post(`${path}/termscondition/Insert`, payload);
                setTermsName('');
                setTermsRows([{ SrNo: 1, Field: '' }]);
                setSnackbar({
                    open: true,
                    message: 'Terms & Condition added successfully',
                    severity: 'success'
                });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600);
                }
            } else if (mode === 'edit') {
                await axios.put(`${path}/termscondition/Update/${id}`, payload);
                setSnackbar({
                    open: true,
                    message: 'Terms & Condition updated successfully',
                    severity: 'success'
                });
                if (onPopupCancel) {
                    setTimeout(() => { onPopupCancel() }, 600);
                }
            }
        } catch (err) {
            console.error('Error saving terms & condition:', err);
            
            if (err.response?.status === 304) {
                setFormError(err.response?.data?.error || 'Record already exists');
            } else {
                setFormError('Something went wrong while saving. Please try again.');
            }
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                handleSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleReset();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    return (
        <>
            <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)' }} />
            <Box sx={{ px: { xs: 1.5, sm: 2.5 }, pt: 2, pb: 1.5 }}>
                <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                    {mode === 'add' || mode === 'comp' ? 'Add Terms & Conditions' : 'Edit Terms & Conditions'}
                </Typography>
            </Box>
            <Divider />
            <Box sx={{ px: { xs: 1.5, sm: 2.5 }, pt: 2, pb: 1 }}>
                    <form onSubmit={handleSubmit} noValidate>
                        <Stack spacing={3}>
                            {/* Terms Number */}
                            <Paper
                                elevation={0}
                                sx={{
                                    p: { xs: 1.5, sm: 2.5 },
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    backgroundColor: '#f8f9fa'
                                }}
                            >
                                <TextField
                                    label="Terms Number"
                                    value={termsName}
                                    onChange={handleTermsNameChange}
                                    fullWidth
                                    required
                                    placeholder="e.g., 1, 2, 3"
                                    type="text"
                                    size="medium"
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*'
                                    }}
                                    helperText="Enter numeric value only"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            borderRadius: 2
                                        }
                                    }}
                                />
                            </Paper>

                            {/* Terms Rows Section */}
                            <Paper
                                elevation={0}
                                sx={{
                                    p: { xs: 1.5, sm: 3 },
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    backgroundColor: '#fafbfc'
                                }}
                            >
                                {/* Section Header */}
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    justifyContent="space-between"
                                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                                    spacing={1.5}
                                    mb={3}
                                >
                                    <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">
                                        <Typography variant="h6" fontWeight={600}>
                                            Terms &amp; Conditions
                                        </Typography>
                                        <Chip
                                            label={`${termsRows.length} ${termsRows.length === 1 ? 'term' : 'terms'}`}
                                            size="small"
                                            color="primary"
                                            sx={{ fontWeight: 600 }}
                                        />
                                    </Stack>
                                    {/* <Button
                                        variant="contained"
                                        size="medium"
                                        startIcon={<AddIcon />}
                                        onClick={handleAddRow}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            px: 2.5,
                                            width: { xs: '100%', sm: 'auto' }
                                        }}
                                    >
                                        Add Term
                                    </Button> */}
                                </Stack>

                                {/* Terms List */}
                                <Stack 
                                    spacing={2}
                                    sx={{
                                        maxHeight: '450px',
                                        overflowY: 'auto',
                                        pr: 0.5,
                                        '&::-webkit-scrollbar': { width: '8px' },
                                        '&::-webkit-scrollbar-track': { 
                                            backgroundColor: '#f1f1f1', 
                                            borderRadius: '8px' 
                                        },
                                        '&::-webkit-scrollbar-thumb': { 
                                            backgroundColor: '#bdbdbd', 
                                            borderRadius: '8px' 
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': { 
                                            backgroundColor: '#9e9e9e' 
                                        }
                                    }}
                                >
                                    {termsRows.map((row, index) => (
                                        <Paper
                                            key={index}
                                            elevation={0}
                                            sx={{
                                                p: { xs: 1.25, sm: 2 },
                                                borderRadius: 2,
                                                border: '2px solid',
                                                borderColor: 'divider',
                                                backgroundColor: 'white',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-2px)'
                                                }
                                            }}
                                        >
                                            <Stack spacing={2}>
                                                {/* Row Header */}
                                                {/* <Stack
                                                    direction="row"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    flexWrap="wrap"
                                                    rowGap={1}
                                                >
                                                    <Chip
                                                        label={`Term ${row.SrNo}`}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: 'primary.main',
                                                            color: 'white',
                                                            fontWeight: 700,
                                                            fontSize: '0.85rem'
                                                        }}
                                                    />

                                                    {/* Action Buttons *\/}
                                                    <Stack direction="row" spacing={0.5}>
                                                        <Tooltip title="Move Up" arrow>
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleMoveUp(index)}
                                                                    disabled={index === 0}
                                                                    sx={{
                                                                        border: '1px solid',
                                                                        borderColor: index === 0 ? 'divider' : 'primary.light',
                                                                        borderRadius: 1.5,
                                                                        '&:hover': {
                                                                            backgroundColor: 'primary.light',
                                                                            color: 'white'
                                                                        }
                                                                    }}
                                                                >
                                                                    <ArrowUpwardIcon fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>

                                                        <Tooltip title="Move Down" arrow>
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleMoveDown(index)}
                                                                    disabled={index === termsRows.length - 1}
                                                                    sx={{
                                                                        border: '1px solid',
                                                                        borderColor: index === termsRows.length - 1 ? 'divider' : 'primary.light',
                                                                        borderRadius: 1.5,
                                                                        '&:hover': {
                                                                            backgroundColor: 'primary.light',
                                                                            color: 'white'
                                                                        }
                                                                    }}
                                                                >
                                                                    <ArrowDownwardIcon fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>

                                                        <Tooltip title="Delete Term" arrow>
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleDeleteRow(index)}
                                                                    disabled={termsRows.length === 1}
                                                                    sx={{
                                                                        border: '1px solid',
                                                                        borderColor: termsRows.length === 1 ? 'divider' : 'error.light',
                                                                        borderRadius: 1.5,
                                                                        color: 'error.main',
                                                                        '&:hover': {
                                                                            backgroundColor: 'error.main',
                                                                            color: 'white'
                                                                        }
                                                                    }}
                                                                >
                                                                    <DeleteIcon fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Stack>
                                                </Stack> */}

                                                {/* Text Field */}
                                                <TextField
                                                    label="Term Description"
                                                    value={row.Field}
                                                    onChange={(e) => handleFieldChange(index, e.target.value)}
                                                    fullWidth
                                                    required
                                                    multiline
                                                    minRows={2}
                                                    maxRows={6}
                                                    placeholder="Enter term or condition..."
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: 2,
                                                            backgroundColor: '#f8f9fa'
                                                        }
                                                    }}
                                                />
                                            </Stack>
                                        </Paper>
                                    ))}
                                </Stack>
                            </Paper>

                            {/* Error Alert */}
                            {formError && (
                                <Alert 
                                    severity="error" 
                                    sx={{ 
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'error.light'
                                    }}
                                >
                                    {formError}
                                </Alert>
                            )}

                            {/* Action Buttons */}
                            <Stack
                                direction={{ xs: 'column-reverse', sm: 'row' }}
                                spacing={2}
                                justifyContent="flex-end"
                                sx={{
                                    pt: 2,
                                    borderTop: '2px solid',
                                    borderColor: 'divider'
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={handleReset}
                                    color="inherit"
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                    startIcon={<SaveIcon />}
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    {mode === 'add' || mode === 'comp' ? 'Save' : 'Update'}
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
            </Box>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default TermsConditionMaster;